var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beeHomeBody"},[_c('homeLeft'),(_vm.childData)?_c('homeRigth',{attrs:{"areausePower":_vm.areausePower}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }